<template>
    <div class="md-layout-item md-medium-size-100 md-xlarge-size-75">
        <h3>Contacts</h3>
        <p class="margin_bottom">Essential contact details for the building/website (will be published online)</p>

        <div class="md-layout md-gutter margin_bottom">
            <label class="md-layout-item md-size-25 md-form-label top_pad_min">
                FM Provision
            </label>
            <div class="md-layout-item md-size-40">
                <md-radio v-for="option in fmProviderOptions" v-model="fmProviderOptionSelected" :key="option" :value="option" :disabled="loading">{{option}}</md-radio>
                <FadeTransition :duration="400" mode="out-in" v-if="fmIsExternal" tag="div" class="val_with_extras">
                    <div>
                    <md-field class="margin_top_slight offset_val">
                        <label for="facilitiesManagerId">Choose Organisation</label>
                        <md-select v-model="contacts.facilitiesManagerId" name="facilitiesManagerId" id="facilitiesManagerId" :disabled="loading">
                            <md-option v-for="fm in fms" :key="fm.id" :value="fm.id">{{fm.name}}</md-option>
                        </md-select>
                    </md-field>
                    <md-button class="md-icon-button md-raised md-dense btn_select_action btn_select_action_top_margin btn_select_bold" @click="addFm" title="Add new FM..." :disabled="loading">
                        <md-icon>add</md-icon>
                    </md-button>
                        </div>
                </FadeTransition>
            </div>
        </div>
        
         <contact-editor :contactId="contacts.facilitiesManagerContactId" 
                         :contacts="fmContacts"
                         :facilitiesManagers="fmsForNewFmContacts"
                         :isStaff="fmContactIsStaff"
                         :hide="!fmContactsDeterminable"
                         v-on:changeId="contacts.facilitiesManagerContactId = $event"
                         v-on:refreshList="refreshFms"
                         label="Facilities Manager"
                         :isDisabled="loading"
                         disabledLabel="Select FM Organisation">
         </contact-editor>

         <contact-editor :contactId="contacts.clientAccountsContactId" 
                         :contacts="internalContacts"
                         :isStaff="true"
                         v-on:changeId="contacts.clientAccountsContactId = $event"
                         v-on:refreshList="refreshInternal"
                         label="Client Accounts"
                         :isDisabled="loading">
         </contact-editor>

         <contact-editor :contactId="contacts.creditControlContactId" 
                         :contacts="internalContacts"
                         :isStaff="true"
                         v-on:changeId="contacts.creditControlContactId = $event"
                         v-on:refreshList="refreshInternal"
                         label="Credit Control"
                         :isDisabled="loading">
         </contact-editor>


        <!--<md-button @click="toggleLoading">Loading</md-button>-->


    </div>
</template>
<script>
    import { FadeTransition } from "vue2-transitions";
    import { extend } from "vee-validate";
    import { required, email, min, max, min_value, max_value, numeric } from "vee-validate/dist/rules";
    extend("email", email);
    extend("required", required);
    extend("min", min);
    extend("max", max);
    extend("min_value", min_value);
    extend("max_value", max_value);
    extend("numeric", numeric);

    import Help from "@/ts/Help";
    import Api from '@/ts/UvApiService';
    import { ControlStates } from '@/ts/ContactComponents';

    import ContactEditor from '@/components/Contact/Editor.vue';
    import Swal from "sweetalert2";



    export default {
        name: "BuildingContacts",
        components: {
            FadeTransition
            , ContactEditor
        },
        props: {
            contacts: {

                facilitiesManagerId: null,
                facilitiesManagerContactId: null,

                clientAccountsContactId: null,
                creditControlContactId: null,

                facilitiesManager: null,
                clientAccounts: null,
                creditControl: null
            },
            name: null,
        },
        data() {
            return {
                loading: true,
                fmProviderOptions: ["In-House", "By Facilities Management Co..."],
                fmProviderOptionSelected: null,
                fms: [],
                internalContacts: [],
                fmContacts: [],
            }
        },
        methods: {
            async toggleLoading() {
                this.loading = !this.loading;
            },
            async addFm() {
                 Swal.fire({
                    title: "Add Facilities Manager?",
                    text: `You will be taken to the Facilities Management Organisation wizard and returned here once complete`,
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonClass: "md-button md-success btn-fill",
                    cancelButtonClass: "md-button md-danger btn-fill",
                    confirmButtonText: "Yes, add new FM",
                    buttonsStyling: false
                }).then(result => {
                    if (result.value) {
                        this.$router.push({ path: '/facilities-managers/new', query: { redirect: this.$route.path } });
                        //this.$router.push("/facilities-managers/new");
                        //TODO:TD nav to FM wizard with a returnUrl ??
                    }
                });
            },
            async refreshInternal() {
                this.internalContacts = await Api.contacts.getAllSimpleInternal();
                  if (!this.fmIsExternal) {
                    await this.setFmContacts();
                }
            },
            async refreshFms() {
                if (!this.fmIsExternal) {
                    await this.refreshInternal();
                }
                await this.setFmContacts();
            },
            getFmProviderOptionSelected() {
                return !this.externalFMSelected ? "In-House" : "By Facilities Management Co...";
            },
            async setFmContacts() {
                this.fmContacts = [];
                if (this.contacts.facilitiesManagerId === null) {
                    this.fmContacts = this.internalContacts;
                }
                else if (!Help.isNullOrUndef(this.contacts.facilitiesManagerId) && Help.isGoodNumber(this.contacts.facilitiesManagerId)) {
                    this.fmContacts = await Api.contacts.getAllSimpleFM(this.contacts.facilitiesManagerId);
                }
                this.deselectFmContactIfNotInList();
            },
            deselectFmContactIfNotInList() {
                var self = this;
                var existsInList = this.fmContacts.some(function (item) {
	                return item.id == self.contacts.facilitiesManagerContactId;
                });
                if (!existsInList) {
                    this.contacts.facilitiesManagerContactId = null;
                }
            }
        },
        computed: {
            fmsForNewFmContacts() {
                if (this.externalFMSelected) 
                    return [this.contacts.facilitiesManagerId];
                return [];
            },
            fmContactIsStaff() {
                return !this.externalFMSelected;
            },
            fmIsExternal() {
                return this.fmProviderOptionSelected === 'By Facilities Management Co...'; //not sure need both of these
            },
            externalFMSelected() {
                return !Help.isNullOrUndef(this.contacts) && !Help.isNullOrUndef(this.contacts.facilitiesManagerId);
            },
            fmContactsDeterminable() {
                return (this.fmIsExternal && this.externalFMSelected) || (!this.fmIsExternal);
            }
        },
        async created() {
            this.fms = await Api.facilitiesManagers.getAllSimple();
            this.fmProviderOptionSelected = this.getFmProviderOptionSelected();//could use a computed get set instead e.g. ,
            this.internalContacts = await Api.contacts.getAllSimpleInternal();
            await this.setFmContacts();
            this.loading = false;
        },
        watch: {
            'contacts.facilitiesManagerId': async function (newVal, oldVal) {
                await this.setFmContacts(); //TODO:TD bug == Select In-House, choose someone, then choose By Fac... doesn't clear the FM Contact ????
            },
            fmProviderOptionSelected(newVal, oldVal) {
                if (this.loading === false) {
                    if (!this.fmIsExternal && (this.contacts.facilitiesManagerId !== null)) {
                        this.contacts.facilitiesManagerId = null;
                    }
                    else {
                        if (this.fmIsExternal) {
                            this.fmContacts = [];
                            this.contacts.facilitiesManagerContactId = null;
                        }
                        else {
                            this.setFmContacts();
                        }
                    }
                }
            },
        }
    }</script>
<style lang="scss">

</style>


